import React from 'react'
import styled from 'styled-components'
import ContactForm from './ContactForm'
import { desktopVW, mobileVW } from '../../styles'
import theme from '../../styles/theme'
import SEO from '../SEO'
import { GatsbyImage } from 'gatsby-plugin-image'

import { useSchemaForLD } from '../../hooks/useSchemaForLD'

const Contact = ({
  location,
  formPhoneNumber,
  formName,
  formMessage,
  formEmail,
  send,
  contactUs,
  contactUsImage,
  seoTitle,
  seoDescription,
  formFailedMessage,
  formSuccessMessage,
  contactSubTitle,
  sendingMessage,
}) => {
  return (
    <>
      <SEO
        isPage
        location={location}
        title={seoTitle}
        description={seoDescription}
        image={contactUsImage ? contactUsImage.file.url : null}
        pageCategory={'Contact'}
        referrer={location.state?.referrer}
        schemas={[
          useSchemaForLD('breadcrumb', {
            item: location.pathname,
            name: seoTitle,
            position: 1,
          }),
        ]}
      />

      <Wrapper>
        <ContactTitle>{contactUs}</ContactTitle>
        <ImageContainer>
          <StyledImage
            image={contactUsImage?.gatsbyImageData}
            alt={contactUsImage.title}
            loading='eager'
          />
        </ImageContainer>
        <ContactFormWrapper>
          <ContactForm
            formPhoneNumber={formPhoneNumber}
            formName={formName}
            formMessage={formMessage}
            formEmail={formEmail}
            send={send}
            formFailedMessage={formFailedMessage}
            formSuccessMessage={formSuccessMessage}
            contactSubTitle={contactSubTitle}
            sendingMessage={sendingMessage}
          />
        </ContactFormWrapper>
      </Wrapper>
    </>
  )
}

const Wrapper = styled.div`
  position: relative;
  margin-top: ${mobileVW(42)};

  @media (min-width: ${theme.breakPoints.desktop}) {
    display: flex;
    justify-content: space-between;
    padding: 0 ${desktopVW(121, 1440)};
    padding-bottom: ${desktopVW(100, 1440)};
    margin-top: ${desktopVW(110, 1440)};
  }
`
const ContactTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: ${theme.fontSize.m50};
  color: ${theme.colors.burntOrange};

  z-index: 1;
  @media (min-width: ${theme.breakPoints.desktop}) {
    font-size: 6.67vw;
  }
`
const ImageContainer = styled.div`
  position: relative;
  top: ${mobileVW(30)};
  left: 50%;
  transform: translateX(-50%);
  width: ${mobileVW(349)};
  height: ${mobileVW(435)};
  /* background-color: blue; */

  @media (min-width: ${theme.breakPoints.desktop}) {
    display: flex;

    top: ${desktopVW(52, 1440)};
    left: 0;
    transform: translateX(0);
    width: ${desktopVW(595, 1440)};
    height: ${desktopVW(744, 1440)};
  }
`
const StyledImage = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
  }
`

const ContactFormWrapper = styled.div`
  position: relative;
  margin-top: ${mobileVW(40)};
  margin-bottom: ${mobileVW(60)};
  padding: 0 ${mobileVW(13)};
  @media (min-width: ${theme.breakPoints.desktop}) {
    top: ${desktopVW(149, 1440)};
    margin-top: 0;
    margin-bottom: 0;
    padding: 0;
    display: flex;
  }
`

export default Contact
